/**
 * @desc waiveFulfilment
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/stockAdjustment/waiveFulfilment`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
